export const OfficeAccessoriesCustomUpdateState = {
	url: '/accessories/update-custom/:bu_id/:prod_id',
	title: 'Office Custom Accessories - Update',
	template: '<office-acc-custom-update-page></office-acc-custom-update-page>',
	params: {
		prod_id: null,
		bu_id: null,
	},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeAccessoriesCustomUpdatePageMod" */
			'@Containers/office-accessories-page/custom-update/custom-update.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
